export default __webpack_public_path__ + "static/media/Money Flag.3bd1190d.png";